// Device-local context — NON-SENSITIVE module progress only (game levels,
// session counts, streak). Sensitive health records (scores, glucose,
// reports) are NEVER written to localStorage; they live server-side under
// the authenticated user's account.

const HEALTH_KEY = "silentscan_v11_health_v1";
const REHAB_KEY = "silentscan_neurorehab_v1";
const SPEAK_KEY = "silentscan_neurospeak_v1";
const MOTOR_KEY = "silentscan_neuromotor_v1";

const read = (k) => {
  try {
    const raw = localStorage.getItem(k);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

// Compact text digest of this device's practice progress, sent with chat so
// the AI can personalise to this user's activity. Contains no scores,
// readings, or reports.
export const buildHistoryContext = () => {
  const parts = [];
  const h = read(HEALTH_KEY);
  if (h) {
    if (h.streak) parts.push(`check-in streak ${h.streak} days`);
    const t = h.today || {};
    const bits = [];
    if (t.steps) bits.push(`${t.steps} steps`);
    if (t.water_ml) bits.push(`${t.water_ml}ml water`);
    if (t.sleep_hours) bits.push(`${t.sleep_hours}h sleep`);
    if (t.mood) bits.push(`mood ${t.mood}`);
    if (bits.length) parts.push(`today: ${bits.join(", ")}`);
  }
  const rehab = read(REHAB_KEY);
  if (rehab?.levels) {
    parts.push(
      `NeuroRehab levels: memory L${rehab.levels.memory}, attention L${rehab.levels.attention}, speed L${rehab.levels.speed}`
    );
  }
  const speak = read(SPEAK_KEY);
  if (speak?.sessions?.length) {
    parts.push(`NeuroSpeak: ${speak.sessions.length} voice practice sessions (level ${speak.level || 1})`);
  }
  const motor = read(MOTOR_KEY);
  if (motor?.sessions?.length) {
    parts.push(`NeuroMotor: ${motor.sessions.length} movement practice sessions (level ${motor.level || 1})`);
  }
  return parts.join("; ");
};
